import React, { useEffect, useState } from 'react';
import apiClient from '../api/client';
const names: any = {
  DRAFT: 'Borrador',
  PENDING: 'Pendiente',
  APPROVED: 'Aprobada',
  REJECTED: 'Rechazada',
  CANCELLED: 'Cancelada',
};
export default function PortalLeaves({
  busy,
  error,
}: {
  busy: (x: string) => void;
  error: (x: string) => void;
}) {
  const [items, setItems] = useState<any[]>([]),
    [types, setTypes] = useState<any[]>([]),
    [balance, setBalance] = useState<any>(),
    [show, setShow] = useState(false),
    [file, setFile] = useState<File | null>(null),
    [form, setForm] = useState<any>({
      leaveTypeId: '',
      startAt: '',
      endAt: '',
      reason: '',
      employeeNotes: '',
    });
  const load = async () => {
    try {
      const [i, t, b] = await Promise.all([
        apiClient.get('/employee-portal/leaves'),
        apiClient.get('/employee-portal/leaves/types'),
        apiClient.get('/employee-portal/leaves/vacation/balance'),
      ]);
      setItems(i.data);
      setTypes(t.data);
      setBalance(b.data);
      setForm((x: any) => ({ ...x, leaveTypeId: x.leaveTypeId || t.data[0]?.id || '' }));
    } catch {
      error('No se pudieron cargar tus licencias.');
    }
  };
  useEffect(() => {
    void load();
  }, []);
  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    busy('Enviando solicitud…');
    try {
      const r = await apiClient.post('/employee-portal/leaves', {
        ...form,
        startAt: new Date(form.startAt).toISOString(),
        endAt: new Date(form.endAt).toISOString(),
      });
      if (file) {
        const fd = new FormData();
        fd.append('file', file);
        await apiClient.post(`/employee-portal/leaves/${r.data.id}/attachment`, fd, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
      }
      setShow(false);
      setFile(null);
      await load();
    } catch (e: any) {
      error(e.response?.data?.message || 'No se pudo enviar la solicitud.');
    } finally {
      busy('');
    }
  };
  const cancel = async (x: any) => {
    if (!confirm('¿Cancelar esta solicitud?')) return;
    await apiClient.patch(`/employee-portal/leaves/${x.id}/cancel`, {});
    await load();
  };
  return (
    <section className="portal-leaves">
      <div className="portal-section-head">
        <div>
          <h2>Licencias y vacaciones</h2>
          {balance && (
            <p>
              {balance.available} días de vacaciones disponibles de {balance.entitled}
            </p>
          )}
        </div>
        <button className="portal-primary" onClick={() => setShow(!show)}>
          Solicitar licencia
        </button>
      </div>
      {show && (
        <form className="portal-leave-form" onSubmit={submit}>
          <label>
            Tipo
            <select
              required
              value={form.leaveTypeId}
              onChange={(e) => setForm({ ...form, leaveTypeId: e.target.value })}
            >
              {types.map((x) => (
                <option value={x.id}>{x.name}</option>
              ))}
            </select>
          </label>
          <label>
            Inicio
            <input
              required
              type="datetime-local"
              value={form.startAt}
              onChange={(e) => setForm({ ...form, startAt: e.target.value })}
            />
          </label>
          <label>
            Finalización
            <input
              required
              type="datetime-local"
              value={form.endAt}
              onChange={(e) => setForm({ ...form, endAt: e.target.value })}
            />
          </label>
          <label>
            Motivo
            <input
              value={form.reason}
              onChange={(e) => setForm({ ...form, reason: e.target.value })}
            />
          </label>
          <label>
            Observaciones
            <textarea
              value={form.employeeNotes}
              onChange={(e) => setForm({ ...form, employeeNotes: e.target.value })}
            />
          </label>
          <label>
            Documentación adjunta
            <input
              type="file"
              accept=".pdf,.jpg,.jpeg,.png"
              onChange={(e) => setFile(e.target.files?.[0] || null)}
            />
          </label>
          <div>
            <button type="button" className="portal-secondary" onClick={() => setShow(false)}>
              Cancelar
            </button>
            <button className="portal-primary">Enviar solicitud</button>
          </div>
        </form>
      )}
      <div className="portal-documents">
        {items.map((x) => (
          <article key={x.id}>
            <div className="receipt-icon">AUS</div>
            <div className="receipt-info">
              <span>{x.leaveType.name}</span>
              <strong>
                {new Date(x.startAt).toLocaleDateString('es-AR')} –{' '}
                {new Date(x.endAt).toLocaleDateString('es-AR')}
              </strong>
              <small>
                {x.quantity} {x.quantityUnit === 'DAYS' ? 'días' : 'horas'}
              </small>
            </div>
            <div className={`portal-status ${x.status === 'APPROVED' ? 'is-signed' : ''}`}>
              {names[x.status]}
            </div>
            {['DRAFT', 'PENDING', 'APPROVED'].includes(x.status) && (
              <button className="portal-secondary" onClick={() => void cancel(x)}>
                Cancelar
              </button>
            )}
          </article>
        ))}
      </div>
    </section>
  );
}
